import { takeLatest, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { setNotification } from 'utils';
import {
    LOAD_COATING_IN,
    START_PALETTE,
    LOAD_JOB_PALETTES_TO_START,
} from '../types/coatingInTypes';
import {
    getCoatingInApi,
    startPaletteApi,
    getJobPalettesToStartApi,
    deleteJobResultApi,
} from '../api/coatingInApi';
import {
    startPaletteRes,
    startPaletteErr,
    loadJobPalettesToStartRes,
    loadJobPalettesToStartErr,
    loadCoatingInRes,
    loadCoatingInErr,
} from '../actions/coatingInActions';

const getLayout = state => state.layout;

// L O A D   C O A T I N G   I N
function* loadCoatingInSaga() {
    try {
        const params = {
            limit: 999,
            offset: 0,
            sort_by: JSON.stringify({ start_date: 1 }),
            joins: JSON.stringify(['job', 'order_item']),
            filter: JSON.stringify({ machine_id: process.env.REACT_APP_MACHINE_COATING_IN_LINE }),
        };

        const result = yield getCoatingInApi(params);

        if (result.status === 200) {
            yield put(loadCoatingInRes(result.data));
        }
    } catch (e) {
        yield put(loadCoatingInErr());
        console.log(e);
    }
}

export function* loadCoatingInWatcher() {
    yield takeLatest(LOAD_COATING_IN, loadCoatingInSaga);
}
// L O A D   C O A T I N G   I N

// S T A R T   P A L E T T E
function* startPaletteSaga(action) {
    const { locale } = yield select(getLayout);

    try {
        const result = yield startPaletteApi({ bulk: action.bulk });

        if (result.status === 202) {
            if (action.bulkDelete.length <= 100) {
                const resultDeleteJobResult = yield deleteJobResultApi({ bulk: action.bulkDelete });
                if (resultDeleteJobResult.status !== 202) { console.log('Error while deleting job-results'); }
            }

            yield put({ type: LOAD_COATING_IN });
            yield put(startPaletteRes(true));
            yield delay(1000);
            yield put(startPaletteRes(false));
            setNotification('success', locale, 'global.success', 'coatingIn.notification.startPaletteSuccess');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(startPaletteErr());
        }
    } catch (e) {
        yield put(startPaletteErr());
        setNotification('error', locale, 'global.error', 'coatingIn.notification.startPaletteError');
        console.log(e);
    }
}

export function* startPaletteWatcher() {
    yield takeLatest(START_PALETTE, startPaletteSaga);
}
// S T A R T   P A L E T T E

// L O A D   J O B   P A L E T T E S   T O   S T A R T
function* loadJobPalettesToStartSaga(action) {
    try {
        const params = {
            limit: 99,
            offset: 0,
            sort_by: JSON.stringify({ created_at: -1 }),
            joins: JSON.stringify(['job', 'order_item']),
            filter: JSON.stringify({
                palette_bar_code: action.paletteNumber,
                machine_ids: process.env.REACT_APP_MACHINE_COATING_IN_LINE,
            }),
        };

        const result = yield getJobPalettesToStartApi(params);

        yield put(loadJobPalettesToStartRes(result.data));
    } catch (e) {
        yield put(loadJobPalettesToStartErr());
        console.log(e);
    }
}

export function* loadJobPalettesToStartWatcher() {
    yield takeLatest(LOAD_JOB_PALETTES_TO_START, loadJobPalettesToStartSaga);
}
// L O A D   J O B   P A L E T T E S   T O   S T A R T
